import { AutogenLayoutRenditionProperties } from "./autogen/AutogenLayoutRenditionProperties";
import { ClickEvent, DropdownItem, FocusEvent,  DataSourceExecutionEvent,  DropdownSelectionEvent, Checkbox } from "@mcleod/components";
import { ModelRow, ModelSearchResult, StringUtil, UserSettings } from "@mcleod/core";
import { ImgLic } from "./ImgLic";

const typesMap = new Map<string, string>();
const overridesMap = new Map<string, number>();
let renlgxLicensed = false;

export class RenditionProperties extends AutogenLayoutRenditionProperties {

  override async onLoad() {
        //console.log(this);
        this.sourceRendOverrideProfiles.search();     //get all fields
        this.sourceRendDocumentProfiles.search();     //get all fields
        this.sourceRenditionRuleProfiles.search();    //get all fields
        this.sourceRenditionTypes.search();           //get all fields
        this.sourceRenditionEmailProfiles.search();
//        this.sourceRenditionFaxProfiles.search();
        this.sourceRenditionFtpProfiles.search();
        renlgxLicensed = await ImgLic.renlgxLicensed();
        this.pbPortalDefs.visible = renlgxLicensed;
        this.textboxRenpXruleid.visible = renlgxLicensed;
        this.textboxRenpXdocid.visible = renlgxLicensed;
        this.sourceRenditionLogixProfiles.search();
        this.SetFtpTypesModes();
  }

  HideAllTabs()
  {
    for( const tab of this.tabsetProperties )
        tab.visible = false;
  }

    /** This is an event handler for the onClick event of checkboxPrint. */
  hideShowDetailPanels(event: ClickEvent) {
        const row = this.sourceRenditionProperties.activeRow;
        this.HideAllTabs();
        if (row == null)
            return;
        const chkbx = event.target as Checkbox;
        let idx = -1;
        if( chkbx == this.checkboxPrint && chkbx.checked )
            idx = 0;
        else if( chkbx == this.checkboxEmail && chkbx.checked )
            idx = 1;
//        else if( chkbx == this.checkboxFax && chkbx.checked )
//            idx = 2;
        else if( chkbx == this.checkboxFax && chkbx.checked )
            idx = 3;
        else if( chkbx == this.checkboxLogix && chkbx.checked )
            idx = 4;

        if (row.get("renp_print") === "Y")
        {
            this.tabPrint.visible = true;
            this.tabsetProperties.selectedIndex = 0;
        }
        if (row.get("renp_email") === "Y")
        {
            this.tabEmail.visible = true;
            this.tabsetProperties.selectedIndex = 1;
        }
//        if (row.get("renp_fax") === "Y")
//        {
//            this.tabFax.visible = true;
//            this.tabsetProperties.selectedIndex = 2;
//        }
        if (row.get("renp_ftp") === "Y")
        {
            this.tabFTP.visible = true;
            this.tabsetProperties.selectedIndex = 3;
        }
        if (row.get("renp_x") === "Y")
        {
            this.tabLogix.visible = true;
            this.tabsetProperties.selectedIndex = 4;
        }
        if( idx >= 0 )
            this.tabsetProperties.selectedIndex = idx;
  }

  SetFtpTypesModes()
  {
        const items: DropdownItem[] = [];
        //items.push({ caption: "Normal FTP", value: "F" });
        //items.push({ caption: "FTP Over SSL TLS (FTPS)", value: "T" });
        //items.push({ caption: "SSH or Secured FTP (SFTP)", value: "S" });
        items.push(new DropdownItem( "F", "Normal FTP" ));
        items.push(new DropdownItem( "T", "FTP Over SSL TLS (FTPS)" ));
        items.push(new DropdownItem( "S", "SSH or Secured FTP (SFTP)" ));
        this.textboxRenpFtptype.items = items;

        const items2: DropdownItem[] = [];
        //items2.push({ caption: "Active Connection or (ACTV)", value: "A" });
        //items2.push({ caption: "Passive Connection or (PASV)", value: "P" });
        items2.push(new DropdownItem( "A", "Active Connection or (ACTV)" ));
        items2.push(new DropdownItem( "P", "Passive Connection or (PASV)" ));
        this.textboxRenpFtpmode.items = items2;

        const items3: DropdownItem[] = [];
        //items3.push({ caption: "Explicit TLS", value: "E" });
        //items3.push({ caption: "Implicit TLS", value: "I" });
        //items3.push({ caption: "Require TLS", value: "R" });
        items3.push(new DropdownItem( "E", "Explicit TLS" ));
        items3.push(new DropdownItem( "I", "Implicit TLS" ));
        items3.push(new DropdownItem( "R", "Require TLS" ));
        this.textboxRenpTlsmode.items = items3;
  }

/** This is an event handler for the afterExecution event of sourceRendOverrideProfiles. */
  sourceRendOverrideProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    overridesMap.clear();
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.ovrh_desc });
        items.push(new DropdownItem( row._data.ovrh_desc, row._data.ovrh_desc ));
        overridesMap.set( row._data.ovrh_desc, row._data.ovrh_id );
    }
    this.textboxRenpOvrid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceRendDocumentProfiles. */
  sourceRendDocumentProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //if( row._data.docp_seq == 1 )
        //items.push({ caption: row._data.docp_id });
        //items.push({ value: row._data.docp_id, caption: row._data.docp_id });
        items.push(new DropdownItem( row._data.docp_id, row._data.docp_id ));
    }
    this.textboxRenpDocid.items = items;
    this.textboxRenpPrintdocid.items = items;
    this.textboxRenpEmaildocid.items = items;
    this.textboxRenpFaxdocid.items = items;
    this.textboxRenpFtpdocid.items = items;
    this.textboxRenpXdocid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceRenditionRuleProfiles. */
  sourceRenditionRuleProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.rulep_id, value: row._data.rulep_id });
        items.push(new DropdownItem( row._data.rulep_id, row._data.rulep_id ));
    }
    this.textboxRenpRuleid.items = items;
    this.textboxRenpPrintruleid.items = items;
    this.textboxRenpEmailruleid.items = items;
    this.textboxRenpFaxruleid.items = items;
    this.textboxRenpFtpruleid.items = items;
    this.textboxRenpXruleid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceRenditionTypes. */
  sourceRenditionTypesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    typesMap.clear();
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.typep_desc });
        items.push(new DropdownItem( row._data.typep_desc, row._data.typep_desc ));
        typesMap.set( row._data.typep_desc, row._data.typep_id );
    }
    this.textboxRenpTypeid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceRenditionEmailProfiles. */
  sourceRenditionEmailProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.emailp_id, value: row._data.emailp_id });
        items.push(new DropdownItem( row._data.emailp_id, row._data.emailp_id ));
    }
    this.textboxRenpEmailid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceRenditionFaxProfiles. */
  sourceRenditionFaxProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.faxp_id, value: row._data.faxp_id });
        items.push(new DropdownItem( row._data.faxp_id, row._data.faxp_id ));
    }
    this.textboxRenpFaxid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceRenditionFtpProfiles. */
  sourceRenditionFtpProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.ftpp_id, value: row._data.ftpp_id });
        items.push(new DropdownItem( row._data.ftpp_id, row._data.ftpp_id ));
    }
    this.textboxRenpFtpid.items = items;
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpTypeid. */
  textboxRenpTypeidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    //if( event.newSelection.caption == "--" )
    //if( event.selection.displayValue == "--" )
    //    row.set("typep_desc", null);
    if( event.selection )
        row.set("renp_typeid", typesMap.get(event.selection.displayValue));
    else
    {
        row.set("typep_desc", null);
        row.set("renp_typeid", null);
    }
}

/** This is an event handler for the onDropdownSelection event of textboxRenpDocid. */
  textboxRenpDocidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row: any = this.sourceRenditionProperties.activeRow;
    //console.log( "renp_recid: " + row._data.renp_recid );
    //console.log( "renp_docid: " + row.data.renp_docid );
    if( event.selection == null )
        row.set("renp_docid", null);
    else
        row.set("renp_docid", event.selection.displayValue);
    //this.textboxRenpDocid.text = event.newSelection.caption;
    //console.log( "renp_docid: " + row._data.renp_docid );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpRuleid. */
  textboxRenpRuleidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_ruleid", null);
    else
        row.set("renp_ruleid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpOvrid. */
  textboxRenpOvridAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row: any = this.sourceRenditionProperties.activeRow;
    //console.log( "renp_recid: " + row._data.renp_recid );
    //console.log( "renp_ovrid: " +  row._data.renp_ovrid );
     if( event.selection == null )
    {
        row.set("ovrh_desc", null);
        row.set("renp_ovrid", null);
    }
    else
        row.set("renp_ovrid", overridesMap.get(event.selection.displayValue));
    //console.log( "renp_ovrid: " + row._data.renp_ovrid );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpPrintruleid. */
  textboxRenpPrintruleidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_printruleid", null);
    else
        row.set("renp_printruleid", event.selection.value );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpPrintdocid. */
  textboxRenpPrintdocidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_printdocid", null);
    else
        row.set("renp_printdocid", event.selection.value );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpEmailid. */
  textboxRenpEmailidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_emailid", null);
    else
        row.set("renp_emailid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpEmailruleid. */
  textboxRenpEmailruleidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_emailruleid", null);
    else
        row.set("renp_emailruleid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpEmaildocid. */
  textboxRenpEmaildocidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_emaildocid", null);
    else
        row.set("renp_emaildocid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpFaxid. */
  textboxRenpFaxidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_faxid", null);
    else
        row.set("renp_faxid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpFaxruleid. */
  textboxRenpFaxruleidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_faxruleid", null);
    else
        row.set("renp_faxruleid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpFaxdocid. */
  textboxRenpFaxdocidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_faxdocid", null);
    else
        row.set("renp_faxdocid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpFtpid. */
  textboxRenpFtpidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_ftpid", null);
    else
        row.set("renp_ftpid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpFtpruleid. */
  textboxRenpFtpruleidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_ftpruleid", null);
    else
        row.set("renp_ftpruleid", event.selection.displayValue );
  }

/** This is an event handler for the onDropdownSelection event of textboxRenpFtpdocid. */
  textboxRenpFtpdocidAfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionProperties.activeRow;
    if( event.selection == null )
        row.set("renp_ftpdocid", null);
    else
        row.set("renp_ftpdocid", event.selection.displayValue );
  }


/** This is an event handler for the afterExecution event of sourceRenditionLogixProfiles. */
  sourceRenditionLogixProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.emailp_id, value: row._data.emailp_id });
        items.push(new DropdownItem( row._data.lgxp_id, row._data.lgxp_id ));
    }
    this.textboxRenpXid.items = items;
  }
}
